"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sendProductClickAnalytics = void 0;
var ProductClickEvent = _interopRequireWildcard(require("@ori-events/product-click"));
var _analyticsData = require("@ori/analytics-data");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const sendProductClickAnalytics = (product, pageIndex)=>{
    var _product_formattedPrice_price, _product_formattedPrice, _product_concept_brand, _product_concept, _product_concept1, _product_concept2;
    var _product_formattedPrice_price_currentPrice, _product_productCode, _product_concept_brand_name, _product_concept_name;
    const event = new CustomEvent(ProductClickEvent.Name, {
        detail: {
            placement: _analyticsData.Placement.DigitalCatalogueECatalogue,
            position: pageIndex + 1,
            products: [
                {
                    formattedPrice: (_product_formattedPrice_price_currentPrice = (_product_formattedPrice = product.formattedPrice) === null || _product_formattedPrice === void 0 ? void 0 : (_product_formattedPrice_price = _product_formattedPrice.price) === null || _product_formattedPrice_price === void 0 ? void 0 : _product_formattedPrice_price.currentPrice) !== null && _product_formattedPrice_price_currentPrice !== void 0 ? _product_formattedPrice_price_currentPrice : '',
                    globalBrandName: '',
                    globalCategoryName: '',
                    globalName: '',
                    itemCode: (_product_productCode = product.productCode) !== null && _product_productCode !== void 0 ? _product_productCode : '',
                    localBrandName: (_product_concept_brand_name = (_product_concept = product.concept) === null || _product_concept === void 0 ? void 0 : (_product_concept_brand = _product_concept.brand) === null || _product_concept_brand === void 0 ? void 0 : _product_concept_brand.name) !== null && _product_concept_brand_name !== void 0 ? _product_concept_brand_name : '',
                    localCategoryName: '',
                    localName: (_product_concept_name = (_product_concept1 = product.concept) === null || _product_concept1 === void 0 ? void 0 : _product_concept1.name) !== null && _product_concept_name !== void 0 ? _product_concept_name : '',
                    media: ((_product_concept2 = product.concept) === null || _product_concept2 === void 0 ? void 0 : _product_concept2.imageUrl) ? [
                        product.concept.imageUrl
                    ] : []
                }
            ]
        }
    });
    window.dispatchEvent(event);
};
exports.sendProductClickAnalytics = sendProductClickAnalytics;
